/**
 * Created by lihanying on 2017/7/6.
 */
import { API_DOMAIN } from '../../config'
import 'whatwg-fetch'
import { fetchData, postData, getCurrentTimeByType } from '../../util/index'
import { message } from 'antd'
import { GETCLUBSTANDBYLIST, GETPERIOD } from './constants'

export const getClubStandbyList = (payload) => {
  return {
    type: GETCLUBSTANDBYLIST,
    payload,
  }
}

export const getPeriod = (payload) => {
  return {
    type: GETPERIOD,
    payload,
  }
}

//支出明细
export function fetchClubStandbyList() {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/BusinessApi/CashExpenditureIn`
    return fetchData(endpoint).then((data) => {
      dispatch(getClubStandbyList(data))
      return data
    })
  }
}

export function fetchTimePeriod(type) {
  return (dispatch, getState) => {
    dispatch(getPeriod(getCurrentTimeByType(type)))
  }
}

//搜索
export function fetchSearchStandby(body) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/BusinessApi/CashExpenditureIn`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      dispatch(getClubStandbyList(data))
      return data
    })
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubStandby/action.js